module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "relationship"
    }
  }, [_vm._v("Relationship")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "relationship"
    },
    model: {
      value: (_vm.relationship),
      callback: function($$v) {
        _vm.relationship = $$v
      },
      expression: "relationship"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "homeTelephone"
    }
  }, [_vm._v("Home Telephone")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "homeTelephone"
    },
    model: {
      value: (_vm.homeTelephone),
      callback: function($$v) {
        _vm.homeTelephone = $$v
      },
      expression: "homeTelephone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "mobile"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "workTelephone"
    }
  }, [_vm._v("Work Telephone")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "workTelephone"
    },
    model: {
      value: (_vm.workTelephone),
      callback: function($$v) {
        _vm.workTelephone = $$v
      },
      expression: "workTelephone"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d93e848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/emergencyContact.vue
// module id = 2115
// module chunks = 0